import { Div, Flex, Text, Tooltip } from '@sendoutcards/quantum-design-ui'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { IconType } from 'src/design_system/atoms/icons/types'
import { useState } from 'src/hooks'

type MembershipRewardsProps = {
  amount?: number
  icon?: IconType
  onClick?: () => void
  tooltipTitle?: string
}

export const MembershipRewards: React.FC<MembershipRewardsProps> = ({
  amount = 0,
  icon = 'reward_coin',
  onClick,
  tooltipTitle = 'Membership Rewards',
}) => {
  const formattedAmount = Math.max(amount, 0).toLocaleString()
  const [isHoveringOn, setIsHoveringOn] = useState(false)

  return (
    <Div
      position="relative"
      display="flex"
      onHoverStart={() => setIsHoveringOn(true)}
      onHoverEnd={() => setIsHoveringOn(false)}
    >
      <Flex
        justifyContent="center"
        alignItems="center"
        backgroundColor="#f5f6f7"
        inset={{ horizontal: 'x1' }}
        style={{ borderRadius: '100px' }}
      >
        <Div
          boxShadow={'mediumLight'}
          inset={{ left: 'x2', right: 'x2_5' }}
          borderRadius="100px"
          backgroundColor={'foreground'}
          display="flex"
          alignItems="center"
          flexDirection="row"
          cursor={onClick ? 'pointer' : undefined}
          onClick={onClick}
          height="45px"
          columnGap="x1"
        >
          <Icon name={icon} size={30} />
          <Text
            type="caption"
            weight="semiBold"
            color="primaryHeading"
            content={formattedAmount}
          />
        </Div>
      </Flex>
      {isHoveringOn && (
        <Flex
          top="115%"
          left="50%"
          transform="translate(-50%)"
          position="absolute"
          zIndex={10000}
          width="auto"
        >
          <Tooltip title={tooltipTitle} direction="top" background="light">
            {null}
          </Tooltip>
        </Flex>
      )}
    </Div>
  )
}

export default MembershipRewards
